export const CREATE_PROGRAM_VARIANT = `
  mutation createProgramVariant($input: CreateProgramVariantInput!, $tenant_id: Int!) {
    createProgramVariant(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProgramVariant {
        id
        name
        program_category_id
        link
        description
        active
        scope
        restricted_visibility
        visible_group_ids
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_PROGRAM_VARIANT = `
  mutation updateProgramVariant($input: UpdateProgramVariantInput!, $tenant_id: Int!) {
    updateProgramVariant(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProgramVariant {
        id
        name
        program_category_id
        link
        description
        active
        scope
        restricted_visibility
        visible_group_ids
        its
        uts
        dts
        created_by
        updated_by
        deleted_by
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_PROGRAM_VARIANT = `
  mutation deleteProgramVariant($id: Int!, $tenant_id: Int!) {
    deleteProgramVariant(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on ProgramVariant {
        id
        name
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
